import React from 'react'
import { Autocomplete, Box, TextField, Typography, createFilterOptions } from '@mui/material'
import { useGetMysteryShopperCompanies } from '../../../api/promotions/dealer/mystery-shopper-company'

// Search the full name list but cap how many options render at once, so opening
// the dropdown on the full list doesn't mount hundreds of DOM nodes.
const filterOptions = createFilterOptions({ limit: 50 })

const BusinessNameAutocomplete = ({ onValueChange, error, helperText }) => {
  const { data: companies = [], isLoading } = useGetMysteryShopperCompanies()

  // val is the chosen company object, or null when cleared (✕/Esc). businessName
  // and address/state are set atomically from the selection — never free text,
  // which keeps the field "must pick from the list".
  const handleChange = (_, val) => {
    onValueChange({
      name: val?.name ?? '',
      address: val?.address ?? '',
      state: val?.state ?? '',
    })
  }

  return (
    <Autocomplete
      autoHighlight
      loading={isLoading}
      options={companies}
      filterOptions={filterOptions}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option._id === value._id}
      onChange={handleChange}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props
        return (
          <Box component='li' key={option._id} {...optionProps}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant='body2' sx={{ fontWeight: 900 }}>
                {option.name}
              </Typography>
              <Typography variant='caption' color='text.secondary' sx={{ fontSize: '0.8rem' }}>
                {option.address}
              </Typography>
            </Box>
          </Box>
        )
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Business Name'
          fullWidth
          error={error}
          helperText={helperText}
        />
      )}
    />
  )
}

export default BusinessNameAutocomplete
